import { Directive } from '@angular/core';
import {
    AbstractControl,
    NG_VALIDATORS,
    ValidationErrors,
    Validator
} from '@angular/forms';
import { appInjector } from '../../../app-injector';
import { InitDataService } from '../../../system-services/InitData';

@Directive({
    selector:
        '[validateSameDomain][ngModel],[validateSameDomain][formControl],[validateSameDomain][formControlName]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: EmailDomainValidatorDirective,
            multi: true
        }
    ],
    standalone: false
})
export class EmailDomainValidatorDirective implements Validator {
    static validateSameDomain(c: AbstractControl): ValidationErrors | null {
        return EmailDomainValidatorDirective.getInitDomains().indexOf(
            EmailDomainValidatorDirective.extractDomain(c.value)
        ) > -1
            ? null
            : {
                  domainMismatch: true
              };
    }

    static extractDomain(email: string): string {
        return email.substring(email.indexOf('@')).toLowerCase();
    }

    static getInitDomains(): string[] {
        const init = appInjector().get(InitDataService);
        return init.companyEmailDomains.allowList;
    }

    validate(control: AbstractControl) {
        return EmailDomainValidatorDirective.validateSameDomain(control);
    }
}
